import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminGallery from "@/pages/AdminGallery";
import AdminContent from "@/pages/AdminContent";
import AdminAIStudio from "@/pages/AdminAIStudio";
import DesignStudio from "@/pages/DesignStudio";
import ShopCheckout from "@/pages/ShopCheckout";
import AdminOrders from "@/pages/AdminOrders";
import AdminDesigns from "@/pages/AdminDesigns";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <ContentProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Landing />} />
              <Route path="/design" element={<DesignStudio />} />
              <Route path="/shop" element={<ShopCheckout />} />
              <Route path="/admin/orders" element={<AdminOrders />} />
              <Route path="/admin/designs" element={<AdminDesigns />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/admin/gallery" element={<AdminGallery />} />
                <Route path="/admin/content" element={<AdminContent />} />
                <Route path="/admin/ai" element={<AdminAIStudio />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </ContentProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
